/* eslint-disable eqeqeq */
export const getSelectValue = (inputValue, options, multi) => {
  let selectValue = multi ? [] : null;

  if (multi && inputValue?.length > 0) {
    selectValue = inputValue.map((value) =>
      options?.find((option) => option.value == value),
    );
  }

  if (!multi) {
    selectValue = options?.find((option) => option.value == inputValue);
  }

  // no undefined should be returned for controlled inputs
  if (selectValue === undefined) {
    selectValue = null;
  }

  return selectValue;
};
